import { database as db, authentication as auth } from '../app-database';

export const guardarDatosPoliza = (sRamo, sPoliza, sInicioVigencia, sInicioVigenciaDate, sCertificado = "", sPlacas = "", sMotor = "") => {
	db.ref("registro/" + auth.currentUser.uid).once("value").then(oValue => {
		db.ref("registro/" + auth.currentUser.uid).set({...oValue.val(),
			"ramo": sRamo,
			"poliza": sPoliza,
			"inicioVigenciaPoliza": sInicioVigencia,
			"inicioVigenciaPolizaDate": sInicioVigenciaDate,
			"certificado": sCertificado,
			"motor": sMotor,
			"placas": sPlacas
		});
	});
	
	return {
		"type": "REGISTRO_POLIZA",
		"ramo": sRamo,
		"poliza": sPoliza,
		"inicioVigenciaPoliza": sInicioVigencia,
		"inicioVigenciaPolizaDate": sInicioVigenciaDate,
		"certificado": sCertificado,
        "motor": sMotor,
        "placas": sPlacas
	}
}
		
export const guardarDatosPersona = (sEmail, sfechaNacimiento, sfechaNacimientoDate, sLadaFijo, sTelefonoFijo, sLadaMovil, sTelefonoMovil, sApaterno = "", sAmaterno = "", sNombres = "", sRfc = "") => {
	db.ref("registro/" + auth.currentUser.uid).once("value").then(oValue => {
		db.ref("registro/" + auth.currentUser.uid).set({...oValue.val(),
			"email": sEmail,
			"fechaNacimiento": sfechaNacimiento,
			"fechaNacimientoDate": sfechaNacimientoDate,
			"ladaFijo": sLadaFijo,
			"telFijo": sTelefonoFijo,
			"ladaCelular": sLadaMovil,
			"telCelular": sTelefonoMovil,
			"apaterno": sApaterno,
	        "amaterno": sAmaterno,
	        "nombres": sNombres,
	        "rfc": sRfc
		});
	});
	
	return {
		"type": "REGISTRO_DATOS",
		"email": sEmail,
		"fechaNacimiento": sfechaNacimiento,
		"fechaNacimientoDate": sfechaNacimientoDate,
		"ladaFijo": sLadaFijo,
		"telFijo": sTelefonoFijo,
		"ladaCelular": sLadaMovil,
		"telCelular": sTelefonoMovil,
		"apaterno": sApaterno,
        "amaterno": sAmaterno,
        "nombres": sNombres,
        "rfc": sRfc
	}
}


// WEBPACK FOOTER //
// ./src/registro/flujo.act.js